"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ColorSelector.scss");
var key_press_1 = require("../../../utils/key-press");
var ColorSelector = function (_a) {
    var data = _a.data, _b = _a.events, events = _b === void 0 ? { onSelect: function () { return null; } } : _b, name = _a.name, _c = _a.options, options = _c === void 0 ? {} : _c, testId = _a.testId;
    var _d = __read(React.useState({
        hideFocus: true,
        selectedIndex: options.defaultIndex ? options.defaultIndex : 0,
    }), 2), state = _d[0], setState = _d[1];
    var hideFocus = state.hideFocus, selectedIndex = state.selectedIndex;
    var colors = data.colors;
    var refOptions = __spread(Array(colors.length)).map(function (_, i) { return i; });
    var onMouseDown = function (e) {
        if (e.button === 0) {
            if (e) {
                e.preventDefault();
            }
            var currentTarget = e.currentTarget;
            var value = currentTarget.value;
            var newSelectedIndex = parseInt(value, 10);
            if (colors[newSelectedIndex].selectable !== false) {
                refOptions[newSelectedIndex].focus();
                setState({ hideFocus: true, selectedIndex: newSelectedIndex });
                if (events &&
                    events.onSelect &&
                    colors[newSelectedIndex].triggerOnSelect !== false) {
                    events.onSelect(colors[newSelectedIndex]);
                }
            }
        }
    };
    var onKeyUp = function (e) {
        var currentTarget = e.currentTarget;
        var value = currentTarget.value;
        var newSelectedIndex = parseInt(value, 10);
        if (colors[newSelectedIndex].selectable !== false) {
            if (key_press_1.KeyPress.enterIsPressed(e)) {
                setState({ hideFocus: false, selectedIndex: newSelectedIndex });
                if (events &&
                    events.onSelect &&
                    colors[newSelectedIndex].triggerOnSelect !== false) {
                    events.onSelect(colors[newSelectedIndex]);
                }
            }
            else if (key_press_1.KeyPress.tabIsPressed(e) ||
                key_press_1.KeyPress.leftArrowIsPressed(e) ||
                key_press_1.KeyPress.rightArrowIsPressed(e)) {
                setState(__assign(__assign({}, state), { hideFocus: false }));
            }
        }
    };
    var onChange = function () { };
    var selectedName = colors[selectedIndex].name;
    return (React.createElement("div", { "data-testid": testId },
        React.createElement("div", { className: styles.colorSelectorLabel + " mar-b-none type-sm" },
            React.createElement("span", { className: options.labelClassName ? options.labelClassName : "" },
                "Color:",
                " "),
            React.createElement("span", { className: options.labelSelectedClassName
                    ? options.labelSelectedClassName
                    : "font-medium" }, colors[selectedIndex].unavailable
                ? colors[selectedIndex].accessibility
                    ? colors[selectedIndex].accessibility
                    : selectedName + " is unavailable"
                : selectedName)),
        React.createElement("div", { "aria-label": "Select a color", className: "" + styles.colorSelectorGroup + (options.groupClassName ? " " + options.groupClassName : "") }, colors.map(function (item, index) {
            return item.hidden ? null : (React.createElement("label", { className: styles.colorSelectorRadioGroup + " color-ui-dark-gray flex-items-center inline-flex rel", key: item.name },
                React.createElement("input", { "aria-disabled": item.unavailable ? true : undefined, className: "absolute", checked: index === selectedIndex, name: name, onChange: onChange, onKeyUp: onKeyUp, onMouseDown: onMouseDown, ref: function (node) {
                        refOptions[index] = node;
                    }, type: "radio", value: index }),
                React.createElement("span", { className: "" + styles.colorSelectorRadioSkin + (" " + (item.unavailable
                        ? styles.colorSelectorRadioSkinDisabled
                        : styles.colorSelectorRadioSkinHover)) + " flex rel", style: { color: item.value } }),
                React.createElement("span", { className: "absolute flex " + styles.colorSelectorOutlineA + (hideFocus ? " " + styles.noBorder : "") }),
                item.unavailable && (React.createElement("span", { className: styles.colorSelectorStrikeThrough })),
                React.createElement("span", { className: "hidden-spoken" }, item.name)));
        }))));
};
exports.default = ColorSelector;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ColorSelector/ColorSelector.js
// module id = 1759
// module chunks = 8